import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
	routes:[
		{
			path:'/',
			name:'Home',
			component:()=>import('@/views/Index.vue'),
			meta: {
				title: '首页'
			 }
		},{
			path:'/search',
			name:'Search',
			component:()=>import('@/views/Search.vue'),
			meta: {
				title: '搜索'
			 }
		},{
			path:'/detail/:tid',
			name:'Detail',
			component:()=>import('@/views/Detail.vue'),
			meta: {
				title: '新闻详情'
			 }
		},{
			path:'/typelist/:id',
			name:'Typelist',
			component:()=>import('@/views/Typelist.vue'),
			meta: {
				title: '新闻列表'
			}
		}
	]
})